import { render, staticRenderFns } from "./edit-letter.vue?vue&type=template&id=0fbe2f41&scoped=true"
import script from "./edit-letter.vue?vue&type=script&lang=js"
export * from "./edit-letter.vue?vue&type=script&lang=js"
import style0 from "./edit-letter.vue?vue&type=style&index=0&id=0fbe2f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe2f41",
  null
  
)

export default component.exports